import type { FaireProductEntity } from "../../entity_types/product";

export const p_thjurwat8x: FaireProductEntity = {
  token: "p_thjurwat8x",
  type: "product",
  name: "SCOOP BACK CAMI IN OXFORD",
  brandToken: "b_9jdg5bykvm",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/f0b26744e2ab79b20441e2c4493f8f3d7c74d6cb79ada18c26497e13e062e279.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0230ff7cef45c6e73918be2e49392a170a4253a8677ccf7e442ac269e1720dac.png",
    "https://cdn.faire.com/fastly/43a381a9c7c863b7d1b075456c3edb9f479cd666326edb46905390f8ef44014d.png",
    "https://cdn.faire.com/fastly/5dc861a6f551fe029928a06943dd1dd5e2ddd527a7044134a3a7dcf47c2ef5b5.jpeg",
    "https://cdn.faire.com/fastly/5dc17aebe031f7c791650ffb7f03cabdfdc4ffb6727466d2a41b196ce875c66b.png",
    "https://cdn.faire.com/fastly/d940e2b1b9f7905e699ea3b950dae17fa123b72ce6ce6379743f8087bcb5e92f.jpeg",
    "https://cdn.faire.com/fastly/71d027e492fb23ffc5bda079a35fa15aae799e6ef653ad6640be1122b39cf053.jpeg",
  ],
  priceDollars: 33.26,
  description:
    "Please note: This cami is made with our Tencel fabric, not our cotton basic fabric. It will feel softer and have more stretch than our usual scoop-back camis.\n\nOur scoop back camisole is designed to make an effortless transition from loungewear to a casual going out look. Our cropped hem shows just the right amount of tummy, the deep scoop back is the cherry on top. Each tank top features lace trim and a satin bow at the center. Pair with high waisted jeans and a unbuttoned flannel for a cute summer look. \n\nMade from ultra-soft, breathable, and moisture-wicking TENCEL™, this top is perfect for sensitive skin. The fabric is sustainably sourced from wood pulp and woven locally in Los Angeles for a luxurious, ethical choice.\n\n * Scoop neck tencel camisole\n\n * Features lace trim & a bow in the center front \n * Made from eco-Tencel ™ \n * Plunging low back \n * Cropped hem ",
  tags: [],
  msrpDollars: 66.51,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:33.993Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
